import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';

@Injectable()
export class AdmManageConcurrentExamsService {

  constructor(private _httpClient: IesHttpClient) {
  }

  isDefault(groupType) {
    return groupType == "default";
  }

  getCapacityConfigs(timeZone: string, groupType: string) {
    if (this.isDefault(groupType)) {
      return this._httpClient.get(AppUrl.getDefaultCapacityConfigs);
    } else {
      let params = "?timeZone=" + timeZone + "&examType=" + groupType;
      return this._httpClient.get(AppUrl.getCapacityConfigs + params);
    }
  }

  updateCapacityConfigs(groupType: string, capacityConfigs: any) {
    if (this.isDefault(groupType)) {
      return this._httpClient.post(AppUrl.updateDefaultCapacityConfigs, capacityConfigs);
    } else {
      return this._httpClient.post(AppUrl.updateCapacityConfigs + "?examType="+groupType, capacityConfigs);
    }
  }
}




// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-concurrent-exams/adm-manage-concurrent-exams.service.ts